<template>
  <div>
    <!-- Error State -->
    <div v-if="error" class="mt-4 text-center p-8 rounded-xl bg-red">
      
      <h3 class="text-lg font-semibold text-white mb-4 nba">
        Unable to load this content
      </h3>
      
      <div>
        <button 
        v-if="showReload"
        @click="reloadPage"
        class="nba font-bold leading-none rounded-[20px] border uppercase border-black bg-black text-white px-3 pt-1.5 pb-1.5 md:px-4 text-[13px] md:text-base outline-none"
        >
          Reload Page
        </button>
      </div>
    </div>
    
    <!-- Success State -->
    <slot v-else />
  </div>
</template>

<script setup>
const props = defineProps({
  error: {
    type: [Error, String, Boolean],
    default: null
  },
  title: {
    type: String,
    default: null
  },
  message: {
    type: String,
    default: null
  },
  showReload: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['retry'])

const handleRetry = () => {
  emit('retry')
}

const reloadPage = () => {
  window.location.reload()
}
</script>